export enum SettingMenu {
    "General" = 1,
    "My Wallet" = 2
}
